module.exports = __webpack_public_path__ + "static/img/ilustra_frente_cnh.9d521cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_frente_cnh.png
// module id = cRcK
// module chunks = 2